import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input, NgZone } from '@angular/core';
import { finalize, delay } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { untilDestroyed } from 'src/app/core';
import { environment } from '@env/environment';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { Main } from 'src/app/core/main.service';
import * as FusionCharts from 'fusioncharts';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, OnDestroy {
  title: string;
  dataSource: any;
  stats = {
    total_users: 0,
    active_users: 0,
    total_sales: {
      count: 0,
      value: 0
    },
    pending_sales: {
      count: 0,
      value: 0
    },
    awards_granted: {
      count: 0,
      value: 0
    },
    awards_pending: {
      count: 0,
      value: 0
    },
    recent_transactions: [],
    recent_awards: [],
    recent_sales: [],
  };
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;
  /* type: string;
  width: string;
  height: string; */
  chartConfig: Object;

  constructor(private router: Router, private route: ActivatedRoute,
    private api: DashboardService, private mainService: Main) {

    this.chartConfig = {
      width: '100%',
      height: '585',
      type: 'timeseries',
      //palettecolors: "FFE4B5",
      dataFormat: 'json',
      // palettecolors: "5d62b5,29c3be,f2726f"
    };
    /* this.type = 'timeseries';
    this.width = '100%';
    this.height = '585'; */
    // This is the dataSource of the chart

    this.dataSource = {
      // Initially data is set as null
      chart: {
        showLegend: 1,
        "palettecolors": "#AB6B51,#00A300",
        "labelFontColor": "#0075c2, #00A300",
        //palettecolors: "AB6B51,412324,4543ff"    
      },
      data: null,
      caption: {
        text: ''
      },
      subcaption: {
        text: 'since 2015'
      },
      yAxis: [
        {
          plot: [
            {
              value: 'Total Users',
              type: 'column'
            },
            {
              value: 'Active Users',
              type: 'line'
            }
          ]
        }
      ]
    };
    this.getDashboardStats();
    //this.getUserStats();
  }

  ngOnInit() {
    let init = localStorage.getItem('init');
    if (init) {
      localStorage.removeItem('init');
      location.reload();
    }
  }

  getDashboardStats() {
    debugger;
    this.api.getDashboardStats('')
      /*  .pipe(
         finalize(() => {
           this.getUserStats();
         }),
         untilDestroyed(this)
       ) */
      .subscribe((res: any) => {
        debugger;
        //this.isLoading = !this.isLoading;
        this.stats = res.data;
        this.getUserStats();
      }, (err) => {
        debugger;
        if (err.status === 401) {
          this.mainService.toast({ title: 'Error: Unauthorized', body: 'Authentication required, please login!', type: 'danger' });
          this.router.navigate(['/login']);
          return;
        }
        err = err;
        //this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: 'Error fetching dashboard stats!', type: 'danger' });
      });
  }

  getUserStats() {
    this.api.getUserStats('').subscribe((res: any) => {
      //this.isLoading = !this.isLoading;
      const data = res.data;
      const schema = res.schema;
      // First we are creating a DataStore
      const fusionDataStore = new FusionCharts.DataStore();
      // After that we are creating a DataTable by passing our data and schema as arguments
      const fusionTable = fusionDataStore.createDataTable(data, schema);
      // Afet that we simply mutated our timeseries datasource by attaching the above
      // DataTable into its data property.
      this.dataSource.data = fusionTable;

    }, (err) => {
      err = err;
      if (err.status === 401) {
        this.mainService.toast({ title: 'Error: Unauthorized', body: 'Authentication required, please login!', type: 'danger' });
        this.router.navigate(['/login']);
        return;
      }
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: 'Error fetching user stats!', type: 'danger' });
    });
  }


  getOverview(lcn: string): void {

  }

  ngOnDestroy(): void {

  }

}
